import { useState } from "react";
import { AddProduct } from "./add-product-dialog";
import { EditProductDialog } from "./edit-product-dialog";
import { DeleteProductDialog } from "./delete-product-dialog";
import ProductsTable from "./products-table";
import type { Product } from "@/types/products/api-types/product-types";

export const ProductsTabContent = () => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState<Product | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleProductClick = (product: Product) => {
    setSelectedProduct(product);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedProduct(null);
    }
  };

  const handleDeleteClick = (product: Product) => {
    setProductToDelete(product);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setProductToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddProduct />
      </div>
      <ProductsTable
        onProductClick={handleProductClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedProduct && (
        <EditProductDialog
          product={selectedProduct}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {productToDelete && (
        <DeleteProductDialog
          product={productToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
